<template>
  <div class="edit-table">
    <vxe-table show-overflow="" ref="fineTable" :data="subjectList" height="300px">
      <vxe-table-column min-width="100" field="code" title="物料编码"></vxe-table-column>
      <vxe-table-column min-width="100" field="name" title="物料名称"></vxe-table-column>
      <vxe-table-column min-width="100" field="classifyName" title="物料分类"></vxe-table-column>
      <vxe-table-column min-width="100" field="kind" title="具体品类"></vxe-table-column>
      <vxe-table-column min-width="100" field="spec" title="规格型号"></vxe-table-column>
      <vxe-table-column min-width="100" field="unitName" title="单位"></vxe-table-column>
      <vxe-table-column min-width="100" field="num" title="数量"></vxe-table-column>
      <vxe-table-column min-width="100" field="price" title="单价"></vxe-table-column>
      <vxe-table-column min-width="100" field="totalPrice" title="总价"></vxe-table-column>
      <vxe-table-column min-width="100" field="preCloseNum" title="已关闭数量"></vxe-table-column>
      <vxe-table-column min-width="100" field="preCloseAmount" title="已关闭金额"></vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
export default {
  name: 'BudgetSubject',
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        this.subjectList = val || [];
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      subjectList: [], // 当前关联费用科目数据
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;
}
</style>
